import mainConfig from './config.main.json';
import supplierConfig from './config.supplier.json';

const config =
  process.env.REACT_APP_INSTANCE_TYPE === 'supplier' ? supplierConfig : mainConfig;

export default config;

export const AUTH_API_URL = config.AUTH_API_URL;
export const API_URL = config.API_URL;
export const ADMIN_API_URL = config.ADMIN_API_URL;
export const S3_API_URL = config.S3_API_URL;
export const OLD_API_URL = config.OLD_API_URL;
export const BASE_URL = config.BASE_URL;
export const Admin_baseURL = config.Admin_baseURL;
export const baseURL = config.baseURL;
export const smartUpApiUrl = config.smartUpApiUrl;
export const AUTH_API_URL_COMPANY = config.AUTH_API_URL_COMPANY;
export const API_URL_COMPANY = config.API_URL_COMPANY;
export const ADMIN_API_URL_COMPANY = config.ADMIN_API_URL_COMPANY;
export const OLD_API_URL_COMPANY = config.OLD_API_URL_COMPANY;
export const PRELOGIN_API_URL_COMPANY = config.PRELOGIN_API_URL_COMPANY;
export const POSTLOGIN_API_URL_COMPANY = config.POSTLOGIN_API_URL_COMPANY;
export const COMPANY_SERVER_API_URL = config.COMPANY_SERVER_API_URL;
export const BASE_API_URL_COMPANY = config.BASE_API_URL_COMPANY;
export const COMPLIANCE_BACKEND_BASE_URL = config.COMPLIANCE_BACKEND_BASE_URL;
